import { createContext } from 'react';
import type { SatelliteConversationFolderTypeV2 } from '@zg-rentals/ts-satellite-client';
import type { SatelliteConversationReadRepliedStatusTypeV2 } from '@zg-rentals/ts-satellite-client';
import type { SatelliteConversationRenterProgressStatusTypeV2 } from '@zg-rentals/ts-satellite-client';

type ContextProps = {
  clientTimeZone: string;
  conversationId: string;
  conversationIdToFilterBy: string | null;
  folder: SatelliteConversationFolderTypeV2;
  isArchivedFolder: boolean;
  isReportedFolder: boolean;
  listingAlias: string;
  // Multi-listing filter; empty means no filter (all listings).
  listingAliases: Array<string>;
  messagingConversationId: string;
  minCriteriaMatches: number | null;
  readRepliedStatus: SatelliteConversationReadRepliedStatusTypeV2;
  renterProgressStatus: SatelliteConversationRenterProgressStatusTypeV2;
};

export const LeadManagementContext = createContext<ContextProps>({} as ContextProps);
export const LeadManagementContextProvider = LeadManagementContext.Provider;
